"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFIXES = exports.formatBytesToBytes = exports.formatBytes = void 0;
const formatBytes_1 = require("./src/formatBytes");
Object.defineProperty(exports, "formatBytes", { enumerable: true, get: function () { return formatBytes_1.formatBytes; } });
const formatBytesToBytes_1 = require("./src/formatBytesToBytes");
Object.defineProperty(exports, "formatBytesToBytes", { enumerable: true, get: function () { return formatBytesToBytes_1.formatBytesToBytes; } });
const constants_1 = require("./src/constants");
Object.defineProperty(exports, "PREFIXES", { enumerable: true, get: function () { return constants_1.PREFIXES; } });
console.log((0, formatBytes_1.formatBytes)(1231, { from: 'B', to: 'MB', fixTo: 3 }));
